module.exports = __webpack_public_path__ + "img/err.aebfa0c1.png";